
export default function filterByKeywords(event, keywordsToSearch) {
  if (keywordsToSearch.length === 0) {
    return true;
  }

  return undefined !== keywordsToSearch.find((inputKeyword) => {
    const keywordRegexp = new RegExp(inputKeyword, 'i');

    return (event.KEYWORDS.toString().match(keywordRegexp))
          || (event.EXECUTOR && event.EXECUTOR.match(keywordRegexp))
          || (event.PARTICIPANT && event.PARTICIPANT.match(keywordRegexp));
  });
}



// WEBPACK FOOTER //
// ./src/services/filters/filterByKeywords.js